import { FC_TRANSFER_LINE_STATUS } from 'components/warehouse/components/fcTransfers/fcTransferReceiveBadgeStyles';

/**
 * Default visibility when `canReceive` / `canEdit` are omitted from the API payload (tech spec §4.2).
 *
 * @param {Record<string, unknown>} item
 * @returns {boolean}
 */
export function getDefaultCanReceiveLine(item) {
    if (item?.canReceive === false) {
        return false;
    }
    if (item?.canReceive === true) {
        return true;
    }
    const s = String(item?.status ?? '').toUpperCase();
    return s === FC_TRANSFER_LINE_STATUS.PENDING;
}

/**
 * @param {Record<string, unknown>} item
 * @returns {boolean}
 */
export function getDefaultCanEditLine(item) {
    if (item?.canEdit === false) {
        return false;
    }
    if (item?.canEdit === true) {
        return true;
    }
    const s = String(item?.status ?? '').toUpperCase();
    return s === FC_TRANSFER_LINE_STATUS.IN_RECEIPT;
}
